<template>
  <div :class="$style.box">
    <header :class="$style.header">
      <img :src="newsItem.from_forum_user_image" />
      <span :class="$style.username">{{ newsItem.from_forum_user_name }}</span>
      <span :class="$style.time">{{ handleTime(newsItem.created_at) }}</span>
      <p :class="$style.type">{{ handleNewsType(newsItem.type) }}</p>
    </header>
    <section :class="$style.reply" @click="handleLinkTo">
      <h3 :class="$style.title">{{ newsItem.conversation_title }}</h3>
      <FlodTextBox v-if="replyContent" :class="$style.text">
        <template #content>
          <div :class="$style.content" v-html="replyTextContent"></div>
        </template>
        <template #floadBtn>
          <p :class="$style.flod">收起</p>
        </template>
        <template #unfloadBtn>
          <p :class="$style.unflod">展开</p>
        </template>
      </FlodTextBox>
      <div
        v-if="hasReplyImgList"
        :class="$style['preview-image-icon']"
        @click.stop="preview(replyImageList)"
      >
        <van-icon name="photo-o" size="15px" style="margin: 3px" />
        <span>查看图片</span>
      </div>
    </section>
    <section :class="$style.message">
      <FlodTextBox v-if="messageContent" :class="$style.text">
        <template #content>
          <div :class="$style.content" v-html="messageTextContent">111</div>
        </template>
        <template #floadBtn>
          <p :class="$style.flod">收起</p>
        </template>
        <template #unfloadBtn>
          <p :class="$style.unflod">展开</p>
        </template>
      </FlodTextBox>
      <div
        v-if="hasMessImgList"
        :class="$style['preview-image-icon']"
        @click.stop="preview(messageImageList)"
      >
        <van-icon name="photo-o" size="18px" color="rgb(155, 209, 240)" />
        <span>查看图片</span>
      </div>
    </section>
  </div>
</template>

<script>
import FlodTextBox from '_c/FlodTextBox';
import { ImagePreview, Icon } from "vant";
import { pastTime } from '@/utils/index';
export default {
  components: {
    FlodTextBox,
    vanIcon: Icon
  },
  props: {
    newsItem: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      replyContent: this.newsItem.comment_content || '', // 被评论内容
      replyTextContent: '',
      replyImageList: [],
      messageContent: this.newsItem.from_comment_content || '', // 评论内容
      messageTextContent: '',
      messageImageList: []
    };
  },
  computed: {
    hasReplyImgList() {
      return this.replyImageList.length
    },
    hasMessImgList() {
      return this.messageImageList.length
    }
  },
  mounted() {
    this.setReplyContent()
    this.setMessageContent()
  },
  methods: {
    // 处理时间
    handleTime(time) {
      return pastTime(time)
    },
    // 判断消息类型
    handleNewsType(type) {
      switch (Number(type)) {
        case 1:
          return "赞了你的贴子";
        case 2:
          return "赞了你的评论";
        case 3:
          return "评论了你的贴子";
        case 4:
          return "回复了你的评论";
        default:
          return ""
      }
    },
    // 处理被评论内容
    setReplyContent() {
      if (!this.replyContent || this.replyContent[0] != '{') return;
      let content = {}
      try {
        content = JSON.parse(this.replyContent);
      } catch {
        return '';
      }
      this.replyTextContent = content.text || ''
      this.replyImageList = content.imgList || []
    },
    // 处理评论内容
    setMessageContent() {
      if (!this.messageContent || this.messageContent[0] != '{') return;
      let content = {}
      try {
        content = JSON.parse(this.messageContent);
      } catch {
        return '';
      }
      this.messageTextContent = content.text || ''
      this.messageImageList = content.imgList || []
    },
    // 图片预览
    preview(imageList) {
      ImagePreview({
        images: [...imageList]
      });
    },
    // 链接跳转
    handleLinkTo() {
      this.$router.push({ name: "gameCircle.details", query: { circleId: this.newsItem.game_circle_id, id: this.newsItem.conversation_id } })
    },
  },
}
</script>

<style lang='scss' module>
@import '~@/styles/mixins.scss';
.box {
  @include border-bottom-1px;
  width: 100%;
  min-height: 100px;
  padding: 15px 30px 5px 25px;
  .header {
    .red-point {
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #f52a2a;
      transform: translate3d(-40px, -11px, 0px);
    }
    > img {
      float: left;
      margin-right: 7px;
      width: 33px;
      height: 33px;
      border-radius: 50%;
    }
    .username {
      display: inline-block;
      margin: 5px 0px 9px 0px;
      font-size: 14px;
      font-weight: bold;
      color: rgba(0, 0, 0, 1);
    }
    .time {
      display: inline-block;
      margin-left: 8px;
      font-size: 8px;
      color: rgba(159, 159, 159, 1);
    }
    .type {
      font-size: 10px;
      color: rgba(159, 159, 159, 1);
    }
  }
  .reply,
  .message {
    position: relative;
    .text {
      width: 100%;
      padding-top: 3px;
      height: auto;
      font-size: 11px;
      .flod,
      .unflod {
        color: rgb(143, 197, 241);
      }
    }
    .preview-image-icon {
      margin-top: 5px;
      > span {
        position: relative;
        bottom: 6px;
        display: inline-block;
        font-size: 9px;
        color: rgba(159, 159, 159, 1);
      }
    }
  }
  .reply {
    margin: 10px 10px 8px 30px;
    padding: 6px 8px;
    width: 88%;
    color: rgba(159, 159, 159, 1);
    background-color: rgb(233, 233, 233, 0.5);
    border-radius: 8px;
    line-height: 20px;
    .title {
      font-size: 13px;
      color: rgb(66, 135, 226);
    }
    .text {
      margin-top: 5px;
      width: 100%;
    }
  }
  .message {
    margin: 8px 15px 8px 30px;
    padding-left: 8px;
  }
}
</style>
